import { b2x } from '@b2x/react/src';
import React from 'react';

import { Breadcrumb } from '../Breadcrumb';
import { Container } from '../Container';
//import { TemplatePageContentType } from '../contentTypes';
import { iconsNames } from '../Icon';
import { ListA } from '../ListA';
import { ListB } from '../ListB';
import { ListC } from '../ListC';
import { Page } from './Page';

export const themeColors = ['primary', 'secondary'] as const;
export type ThemeColor = (typeof themeColors)[number];

export const TemplatePage = () => {
  //const page = b2x.usePage<TemplatePageContentType>();

  const { sortingOptions } = b2x.useSortingOptions([
    { orderBy: 'PRIORITY', orderingType: 'ASC' },
    { orderBy: 'PRIORITY', orderingType: 'DESC' },
    { orderBy: 'NAME', orderingType: 'ASC' },
    { orderBy: 'NAME', orderingType: 'DESC' },
    { orderBy: 'PRICE', orderingType: 'ASC' },
    { orderBy: 'PRICE', orderingType: 'DESC' },
    { orderBy: 'ID', orderingType: 'ASC' },
    { orderBy: 'ID', orderingType: 'DESC' },
  ]);

  return (
    <Page noPaddingTop>
      <TemplateSection title="Breadcrumb">
        <Container>
          <Breadcrumb />
        </Container>
      </TemplateSection>
      <TemplateSection title="Grid System">
        <b2x.template.GridSystem />
      </TemplateSection>
      <TemplateSection title="Spacing">
        <b2x.template.Spacing />
      </TemplateSection>
      <TemplateSection title="Typography">
        <b2x.template.Typography
          variants={[
            { className: 'display-1', name: 'Display 1' },
            { className: 'display-2', name: 'Display 2' },
            { className: 'display-3', name: 'Display 3' },
            { className: 'display-4', name: 'Display 3' },
            { className: 'display-5', name: 'Display 5' },
            { className: 'display-6', name: 'Display 6' },
            { className: 'h1', name: 'Heading 1' },
            { className: 'h2', name: 'Heading 2' },
            { className: 'h3', name: 'Heading 3' },
            { className: 'h4', name: 'Heading 4' },
            { className: 'h5', name: 'Heading 5' },
            { className: 'h6', name: 'Heading 6' },
            { className: '', name: 'Normal text' },
            { className: 'small ', name: 'Small text' },
            { className: 'extra-small', name: 'Extra small text' },
            { className: 'fw-bold', name: 'Bold text' },
            { className: 'fw-normal', name: 'Normal text' },
          ]}
        />
      </TemplateSection>
      <TemplateSection title="Colors">
        <b2x.template.Colors
          colors={[
            { background: 'primary', text: 'white' },
            { background: 'secondary', text: 'black' },
            { background: 'white', text: 'black' },
            { background: 'promo', text: 'white' },
            { background: 'violet', text: 'white' },
            { background: 'blu-light', text: 'white' },
            { background: 'warning', text: 'white' },
            { background: 'success', text: 'white' },
            { background: 'danger', text: 'white' },
            { background: 'gray-100', text: 'black' },
            { background: 'gray-200', text: 'black' },
            { background: 'gray-300', text: 'white' },
            { background: 'gray-400', text: 'white' },
          ]}
        />
      </TemplateSection>
      <TemplateSection title="Icons">
        <b2x.template.Icons names={iconsNames} />
      </TemplateSection>
      <TemplateSection title="Form">
        <Container>
          <b2x.ExampleForm />
        </Container>
      </TemplateSection>
      <TemplateSection title="Buttons">
        <b2x.template.Buttons
          backgrounds={['white']}
          iconsOrLabels={['onlyLabel', 'onlyIcon', 'IconLeftAndLabel', 'IconRightAndLabel']}
          sizes={[undefined]}
          variants={['primary', 'link']}
        />
      </TemplateSection>
      <TemplateSection title="Table">
        <Container>
          <b2x.Table border="light" className="border" colNumber={10} responsive xAlignment="center">
            <b2x.TableHead variant="light">
              <tr>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((th) => (
                  <th key={th}>th{th}</th>
                ))}
              </tr>
            </b2x.TableHead>
            <b2x.TableBody>
              {[1, 2, 3, 4, 5].map((tr) => (
                <tr key={tr}>
                  {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((td) => (
                    <td key={td}>
                      tr{tr} td{td}
                    </td>
                  ))}
                </tr>
              ))}
            </b2x.TableBody>
          </b2x.Table>
        </Container>
      </TemplateSection>
      <TemplateSection title="Dropdowns">
        <Container>
          <div className="row">
            <b2x.template.Dropdowns
              hideAlignments
              hideAutoClose
              hideComponent
              hideDarkVariant
              hideDirections
              hideOffsets
              sizes={[undefined]}
              variants={['primary', 'secondary', 'link']}
            />
          </div>
        </Container>
      </TemplateSection>

      <TemplateSection title="Tabs">
        <Container>
          <b2x.template.Tabs />
        </Container>
      </TemplateSection>

      <TemplateSection title="Accordion">
        <Container>
          <div className="row">
            <div className="col-lg-6 mb-5">
              <b2x.Accordion id="AccordionExample">
                <b2x.AccordionItem id="One" title="Title ONE">
                  <b2x.LoremIpsum />
                </b2x.AccordionItem>
                <b2x.AccordionItem id="Two" title="Title Two">
                  <b2x.LoremIpsum />
                </b2x.AccordionItem>
              </b2x.Accordion>
            </div>
          </div>
        </Container>
      </TemplateSection>
      <TemplateSection title="Lists">
        <Container>
          <div className="mb-4">
            <h4>List A</h4>
            <ListA
              items={[
                { cta: 'https://www.google.com', label: 'Lorem' },
                { cta: 'https://www.google.com', label: 'ipsum' },
                { cta: 'https://www.google.com', label: 'dolor' },
                { cta: 'https://www.google.com', label: 'sit' },
                { cta: 'https://www.google.com', label: 'amet' },
              ]}
            />
          </div>
          <div className="bg-gray-100 p-3">
            <div className="row">
              <div className="col-12 col-sm-6 col-md-5 col-lg-4 col-xl-3 mb-3 mb-sm-0">
                <h4 className="">List B</h4>
                <ListB
                  items={[
                    // { active: true, icon: 'profile', label: 'Lorem', link: 'https://www.google.com' },
                    { icon: 'wishlist', label: 'ipsum', link: 'https://www.google.com' },
                    { icon: 'cart', label: 'dolor', link: 'https://www.google.com' },
                    { icon: 'mail', label: 'sit', link: 'https://www.google.com' },
                  ]}
                />
              </div>
              <div className="col-12 col-sm-6 col-md-5 col-lg-4 col-xl-3">
                <h4 className="">List C</h4>
                <ListC
                  items={[
                    { label: 'Lorem', link: 'https://www.google.com' },
                    { label: 'Ipsum', link: 'https://www.google.com' },
                    { label: 'Dolor', link: 'https://www.google.com' },
                    { label: 'Sit', link: 'https://www.google.com' },
                    { label: 'Amet', link: 'https://www.google.com' },
                  ]}
                  title="Servizio Clienti"
                />
              </div>
            </div>
          </div>
        </Container>
      </TemplateSection>

      <TemplateSection title="Modals">
        <Container>
          <b2x.template.Modals />
        </Container>
      </TemplateSection>
      <TemplateSection title="Offcanvas">
        <Container>
          <b2x.template.Offcanvasses />
        </Container>
      </TemplateSection>
      <TemplateSection title="Ordinamento prodotti">
        <Container>
          <b2x.Dropdown label="Ordina per">
            {sortingOptions.map((sortingOption) => (
              <b2x.DropdownItem active={sortingOption.active} key={sortingOption.label} onClick={sortingOption.onClick}>
                {sortingOption.label}
              </b2x.DropdownItem>
            ))}
          </b2x.Dropdown>
        </Container>
      </TemplateSection>
      <TemplateSection title="Pagination">
        <Container>
          <b2x.template.Paginations />
        </Container>
      </TemplateSection>
    </Page>
  );
};

interface TemplateSectionProps {
  children?: React.ReactNode;
  title?: string;
}

const TemplateSection = ({ children, title }: TemplateSectionProps) => {
  return (
    <section className="my-5">
      <>
        {title && (
          <div className="container-xxl">
            <h1 className="mb-4">{title}</h1>
          </div>
        )}
        {children}
      </>
    </section>
  );
};
